import { useOverlayContext } from 'seagull';
export const useContactRowModal = (biName, renderModal)=>{
    const { showModal } = useOverlayContext();
    return (contact)=>void showModal({
            biName,
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal } = param;
                return renderModal(contact, dismissModal);
            }
        });
};
